import { LanguageModel } from "./../../../../../../apps/merchant-portal/src/modules/shared/models/language.model";
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { MatIconModule } from "@angular/material/icon";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
@Component({
  standalone: true,
  selector: "er-language-selector",
  templateUrl: "language-selector.component.html",
  imports: [MatIconModule],
  styleUrls: ["language-selector.component.scss"],
})
export class LanguageSelectorComponent {
  @Input({ required: true })
  public availableLanguages!: LanguageModel[];

  // Regarding the comment below, this here should be readonly and then fix the errors!
  @Input()
  public selectedLanguage?: LanguageModel;

  @Output()
  public languageChange: EventEmitter<LanguageModel> =
    new EventEmitter<LanguageModel>();

  @ViewChild("dropdownTrigger")
  public dropdownTrigger!: ElementRef;
  @ViewChild("dropdownTemplate")
  public dropdownTemplate!: TemplateRef<any>;

  public isVisible = false;
  private overlayRef: OverlayRef | null = null;

  private readonly bsLocaleService = inject(BsLocaleService);

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
  ) {}

  public toggleLanguagesDropdown() {
    if (this.isVisible) {
      this.hideLanguagesDropdown();
    } else {
      this.showLanguagesDropdown();
    }
  }

  public onLanguageSelect(selectedLanguage: LanguageModel): void {
    this.bsLocaleService.use(selectedLanguage.name);
    // TODO: IT IS VERY WRONG TO CHANGE INPUT PROPERTIES LIKE THIS, they should be used only as input, not to hold state
    this.selectedLanguage = selectedLanguage;
    this.languageChange.emit(this.selectedLanguage);
    this.hideLanguagesDropdown();
  }

  private showLanguagesDropdown(): void {
    const dropdownTriggerRectangle: any =
      this.dropdownTrigger.nativeElement.getBoundingClientRect();
    const overlayPosition = {
      top: dropdownTriggerRectangle.bottom + window.scrollY,
      left: dropdownTriggerRectangle.left + window.scrollX,
    };

    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .global()
        .top(`${overlayPosition.top}px`)
        .left(`${overlayPosition.left}px`),
      hasBackdrop: true,
    });

    this.overlayRef.attach(
      new TemplatePortal(this.dropdownTemplate, this.viewContainerRef),
    );
    this.overlayRef.backdropClick().subscribe(() => {
      this.hideLanguagesDropdown();
    });

    this.isVisible = true;
  }

  private hideLanguagesDropdown(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.isVisible = false;
    }
  }

  public get displaySelectedLanguage(): string | undefined {
    return this.selectedLanguage?.name.toUpperCase();
  }
}
